import React, { useEffect, useRef, useState } from "react";
import "./dailywork.css";
import { ChevronLeft, ChevronRight, Save, SquarePen } from "lucide-react";
import KeyModal from "./keyModal";
import CredoModal from "./CredoModal";
import { addDays, subDays, isSameDay } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";
import HashLoader from "react-spinners/HashLoader";
import { useNavigate } from "react-router-dom";
import Next90Modal from "./Next90Modal";
import IgniteModal from "./IgniteModal";
import Next30Modal from "./Next30Modal";
import SaturdayComp from "./SaturdayComp";
import SundayComp from "./SundayComp";
import * as Tooltip from "@radix-ui/react-tooltip";
import "./videotooltip.css";

const keys = [
  {
    id: 1,
    name: "KEY 1",
    openModal: false,
  },
  {
    id: 2,
    name: "KEY 2",
    openModal: false,
  },
  {
    id: 3,
    name: "KEY 3",
    openModal: false,
  },
  {
    id: 4,
    name: "KEY 4",
    openModal: false,
  },
];

const DailyWork = () => {
  const userId = JSON.parse(localStorage.getItem("userDetails"))._id;
  const createdAt = JSON.parse(localStorage.getItem("userDetails")).created_at;
  const [checkedKeys, setCheckedKeys] = useState({
    key1_track: false,
    key2_track: false,
    key3_track: false,
    key4_track: false,
  });
  const [userKey, setUserKey] = useState(null);
  const [editWin, setEditWin] = useState(false);
  const [editWhat, setEditWhat] = useState(false);
  const [editWish, setEditWish] = useState(false);
  const [editWho, setEditWho] = useState(false);
  const [editCorrection, setEditCorrection] = useState(false);
  const [activeKey, setActiveKey] = useState(null);
  const [credoModal, setCredoModal] = useState(false);
  const [showPastCalendar, setShowPastCalendar] = useState(false);
  const [showFutureCalendar, setShowFutureCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loadingPage, setLoadingPage] = useState(false);
  const [next90Modal, setNext90Modal] = useState(false);
  const [next30Modal, setNext30Modal] = useState(false);
  const [ignitionModal, setIgnitionModal] = useState(false);
  const [checkPastWeek, setCheckPastWeek] = useState(false);
  const [updateKeyData, setUpdateKeyData] = useState(false);
  const [prevDays, setPrevDays] = useState(0);

  const extractedCreatedDate = new Date(createdAt).toISOString().split("T")[0];
  const extractedSelecteddDate = new Date(selectedDate)
    .toISOString()
    .split("T")[0];

  const isDateOlderThanToday =
    new Date(selectedDate) < new Date().setHours(0, 0, 0, 0);

  const textWinRef = useRef();
  const textWhatRef = useRef();
  const textCorrectionRef = useRef();
  const textWishRef = useRef();
  const textWhoRef = useRef();
  const calendarRef = useRef(null);

  const [textWin, setTextWin] = useState("");
  const [textWhat, setTextWhat] = useState("");
  const [textCorrection, setTextCorrection] = useState("");
  const [textWish, setTextWish] = useState("");
  const [textWho, setTextWho] = useState("");
  const [isMeditateChecked, setIsMeditateChecked] = useState(false);
  const [isCredoChecked, setIsCredoChecked] = useState(false);
  const [trackStatus, setTrackStatus] = useState("");
  const [score, setScore] = useState(0);

  const today = new Date();
  const isSaturday = selectedDate.getDay() === 6;
  const isSunday = selectedDate.getDay() === 0;

  const toggleNext90Modal = () => {
    setNext90Modal(!next90Modal);
  };

  const toggleNext30Modal = () => {
    setNext30Modal(!next30Modal);
  };

  const toggleIgnitionModal = () => {
    setIgnitionModal(!ignitionModal);
  };

  const handleCheckbox = (key, value) => {
    if (key === "meditate") setIsMeditateChecked(value);
    if (key === "credo") setIsCredoChecked(value);

    sendData({
      meditate: key === "meditate" ? value : isMeditateChecked,
      credo: key === "credo" ? value : isCredoChecked,
      trackStatus,
    });
  };

  const handleTrackCheckboxChange = (status) => {
    setTrackStatus(status);
    sendData({
      meditate: isMeditateChecked,
      credo: isCredoChecked,
      trackStatus: status,
    });
  };

  const handlePastDateClick = () => {
    if (extractedCreatedDate == extractedSelecteddDate) {
      return null;
    }
    const newDate = subDays(selectedDate, 1);
    setSelectedDate(newDate);
    setShowPastCalendar(false);
    setShowFutureCalendar(false);
    setPrevDays((prev) => prev + 1);
  };

  const handleFutureDateClick = () => {
    const newDate = addDays(selectedDate, 1);
    setSelectedDate(newDate);
    setShowFutureCalendar(false);
    setPrevDays((prev) => prev - 1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowPastCalendar(false);
        setShowFutureCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getData = async (dontLoadPage = false) => {
    const payload = {
      date: selectedDate,
    };

    try {
      if (!dontLoadPage) setLoadingPage(true);
      const res = await apiServiceHandler(
        "POST",
        "api/daily/task/fetch",
        payload
      );
      if (res.status && res.data[userId]) {
        setTextWin(res?.data[userId]?.win);
        setTextWhat(res?.data[userId]?.what);
        setTextCorrection(res?.data[userId]?.correction);
        setTextWho(res?.data[userId]?.who);
        setTextWish(res?.data[userId]?.wish);
        setIsMeditateChecked(res?.data[userId]?.meditate);
        setIsCredoChecked(res?.data[userId]?.credo);
        setTrackStatus(
          (res?.data[userId]?.on_track === true && "on") ||
            (res?.data[userId]?.off_track === true && "off")
        );
      }
      setLoadingPage(false);
    } catch (error) {
      console.log("Failed to get data");
      setTextWin("");
      setTextWhat("");
      setTextCorrection("");
      setTextWho("");
      setTextWish("");
      setIsMeditateChecked(false);
      setIsCredoChecked(false);
      setTrackStatus("");
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const dontLoadPage = true;
    getData(dontLoadPage);
    setEditCorrection(false);
    setEditWhat(false);
    setEditWho(false);
    setEditWin(false);
    setEditWish(false);
  }, [selectedDate]);

  const sendData = async (updatedState) => {
    const dontLoadPage = true;
    const payload = {
      win: textWin,
      wish: textWish,
      what: textWhat,
      who: textWho,
      correction: textCorrection,
      meditate: updatedState?.meditate ?? isMeditateChecked,
      credo: updatedState?.credo ?? isCredoChecked,
      on_track:
        (updatedState && (updatedState?.trackStatus === "on" ? true : false)) ??
        (trackStatus === "on" ? true : false),
      off_track:
        (updatedState &&
          (updatedState?.trackStatus === "off" ? true : false)) ??
        (trackStatus === "off" ? true : false),
    };
    try {
      const res = await apiServiceHandler("POST", "api/daily/task", payload);
      if (res.status) {
        toastr.success("Your daily progress has been updated");
        fetchData();
        getData(dontLoadPage);
      }
    } catch (error) {
      console.log("Failed to get data");
    }
  };

  const openCredoModal = () => {
    setCredoModal(true);
  };

  const closeCredoModal = () => {
    setCredoModal(false);
  };

  const openKeyModal = (keyId) => {
    setActiveKey(keyId);
  };

  const closeKeyModal = () => {
    setActiveKey(null);
  };

  const handleEdit = (editType, setEditType, ref) => {
    if (editType) {
      sendData();
    }
    setEditType(!editType);

    ref.current.selectionStart = ref.current.value.length;
    ref.current.selectionEnd = ref.current.value.length;
  };

  const editStates = [editWin, editWhat, editCorrection, editWish, editWho];
  useEffect(() => {
    [
      textWinRef,
      textWhatRef,
      textCorrectionRef,
      textWishRef,
      textWhoRef,
    ].forEach((ref, i) => {
      if (editStates[i]) ref.current?.focus();
    });
  }, [editWin, editWhat, editCorrection, editWish, editWho]);

  const isWithinWeekRange = () => {
    const today = new Date();
    const todayDay = today.getDay();

    if (todayDay - prevDays < 0) {
      return false;
    } else {
      return true;
    }
  };

  const fetchKeysData = async () => {
    const payload = {
      date: selectedDate,
    };
    try {
      const res = await apiServiceHandler("POST", "api/key4/fetch", payload);
      if (res.status && res.data?.length > 0) {
        const fetchedKeys = res.data[0];
        setUserKey(fetchedKeys._id);
        if (isSunday) {
          if (
            selectedDate.toISOString().split("T")[0] ===
            fetchedKeys.date.split("T")[0]
          ) {
            setCheckedKeys({
              key1_track: fetchedKeys.key1_track,
              key2_track: fetchedKeys.key2_track,
              key3_track: fetchedKeys.key3_track,
              key4_track: fetchedKeys.key4_track,
            });
          } else {
            setCheckedKeys({
              key1_track: false,
              key2_track: false,
              key3_track: false,
              key4_track: false,
            });
          }
        } else {
          setCheckedKeys({
            key1_track: fetchedKeys.key1_track,
            key2_track: fetchedKeys.key2_track,
            key3_track: fetchedKeys.key3_track,
            key4_track: fetchedKeys.key4_track,
          });
        }
      } else {
        setCheckedKeys({
          key1_track: false,
          key2_track: false,
          key3_track: false,
          key4_track: false,
        });
      }
    } catch (error) {
      console.log("Failed to fetch data");
    }
  };

  useEffect(() => {
    fetchKeysData();
  }, []);

  useEffect(() => {
    if (updateKeyData) {
      fetchKeysData();
    }
    setUpdateKeyData(false);
  }, [updateKeyData]);

  useEffect(() => {
    const isPastWeek = isWithinWeekRange();
    setCheckPastWeek(isPastWeek);
    fetchKeysData();
  }, [selectedDate]);

  const updateKeyTrack = async (updatedKeys) => {
    const payload = Object.keys(updatedKeys).reduce((acc, key) => {
      acc[key] = updatedKeys[key];
      return acc;
    }, {});
    payload["_id"] = userKey;
    try {
      const res = await apiServiceHandler("POST", "api/key4/update", payload);
      if (res.status) {
        toastr.success("Key track updated successfully");
        setUpdateKeyData(true);
        fetchData();
      }
    } catch (error) {
      console.error("Error updating key track:", error);
    }
  };

  const handleCheckboxChange = (id) => {
    setCheckedKeys((prevState) => {
      const keyName = `key${id}_track`;
      const updatedKeys = { ...prevState, [keyName]: !prevState[keyName] };
      updateKeyTrack(updatedKeys);

      return updatedKeys;
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiServiceHandler(
        "POST",
        "api/weekTask/saturday",
        { date: new Date() }
      );
      const apiResponse = response.data;
      if (Object.keys(apiResponse).length) {
        setScore(apiResponse[Object.keys(apiResponse)]);
      }
    } catch (error) {
      throw new Error(error, "error message");
    }
  };

  const [isKeyTooltipOpen, setIsKeyTooltipOpen] = useState(false)
  const [isCredoTooltipOpen, setIsCredoTooltipOpen] = useState(false)
  const [isMeditateTooltipOpen, setIsMeditateTooltipOpen] = useState(false)
  const [isTrackTooltipOpen, setIsTrackTooltipOpen] = useState(false)
  const [isCorrectionTooltipOpen, setIsCorrectionTooltipOpen] = useState(false)
  const [isWinTooltipOpen, setIsWinTooltipOpen] = useState(false)
  const [isWishTooltipOpen, setIsWishTooltipOpen] = useState(false)
  const [isWhatTooltipOpen, setIsWhatTooltipOpen] = useState(false)
  const [isWhoTooltipOpen, setIsWhoTooltipOpen] = useState(false)

  return !loadingPage ? (
    <>
      <div className="daily-work-page-section">
        <div className="daily-work-page-section-header">
          <div className="daily-work-header">
            <div className="daily-work-header-top">
              <div className="daily-work-header-content">
                <div className="daily-work-header-heading">
                  <div className="daily-work-key">
                    <Tooltip.Provider>
                      <Tooltip.Root  open={isKeyTooltipOpen} onOpenChange={setIsKeyTooltipOpen}>
                        <Tooltip.Trigger asChild>
                          <div
                            className="question-mark"
                            style={{ position: "absolute" }}
                            onClick={() => setIsKeyTooltipOpen((prev) => !prev)}
                          >
                            ?
                          </div>
                        </Tooltip.Trigger>
                        <Tooltip.Portal>
                          <Tooltip.Content
                            className="TooltipContent"
                            sideOffset={5}
                            onPointerDownOutside={() => setIsKeyTooltipOpen(false)}
                          >
                            <video
                              width="360"
                              height="240"
                              controls
                              src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+15+Defining+Key+4.mp4"
                            ></video>
                            <Tooltip.Arrow className="TooltipArrow" />
                          </Tooltip.Content>
                        </Tooltip.Portal>
                      </Tooltip.Root>
                    </Tooltip.Provider>
                    <div className="daily-work-key-items">
                      {keys.map((key) => (
                        <div
                          className="daily-work-key-item"
                          key={key.id}
                          onClick={() => openKeyModal(key.id)}
                          style={
                            checkedKeys[`key${key.id}_track`]
                              ? { background: "#26262f" }
                              : {}
                          }
                        >
                          <ChevronRight
                            size={28}
                            style={{
                              cursor: "pointer",
                              color: checkedKeys[`key${key.id}_track`]
                                ? "#fff"
                                : "#26262f",
                            }}
                          />
                          <div
                            className="daily-work-key-word"
                            style={
                              checkedKeys[`key${key.id}_track`]
                                ? { color: "#fff" }
                                : {}
                            }
                          >
                            {key.name}
                          </div>
                          <div
                            class="round"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <input
                              type="checkbox"
                              id={`checkbox-${key.id}`}
                              checked={
                                checkedKeys[`key${key.id}_track`] || false
                              }
                              disabled={!checkPastWeek}
                              onChange={() => handleCheckboxChange(key.id)}
                            />
                            <label
                              htmlFor={`checkbox-${key.id}`}
                              style={
                                !checkPastWeek
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                            ></label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="daily-work-page-section-body">
          <div className="daily-work-page-week-details">
            <ChevronLeft
              size={32}
              style={{
                color:
                  extractedCreatedDate == extractedSelecteddDate
                    ? "#d3d3d3"
                    : "#26262f",
                cursor:
                  extractedCreatedDate == extractedSelecteddDate
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={handlePastDateClick}
            />
            <div className="day-details">
              <h3>{selectedDate && selectedDate.toDateString()}</h3>
              <div className="score-details">
                Score: <span className="score">{score}/44</span>
              </div>
            </div>
            <ChevronRight
              size={32}
              style={{
                color: isSameDay(selectedDate, today) ? "#d3d3d3" : "#26262f",
                cursor: isSameDay(selectedDate, today)
                  ? "not-allowed"
                  : "pointer",
              }}
              onClick={
                !isSameDay(selectedDate, today) ? handleFutureDateClick : null
              }
            />
          </div>
        </div>
      </div>

      <div className="daily-work-page-section">
        <div className="daily-work-page-section-header">
          <div className="daily-work-header">
            <div className="daily-work-header-top">
              <div className="daily-work-header-content">
                <div className="daily-work-header-heading">
                  {!isSaturday && !isSunday ? (
                    <div className="daily-work-key">
                      <div className="daily-work-body-items">
                        {/* Body Left */}
                        <div className="daily-work-body-left-items">
                          <div className="daily-work-tooltip">
                            <div
                              className="daily-work-body-item"
                              onClick={openCredoModal}
                              style={{
                                backgroundColor: isCredoChecked
                                  ? "#26262f"
                                  : "",
                                cursor: isDateOlderThanToday
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <ChevronRight
                                size={28}
                                style={{
                                  color: isCredoChecked ? "#fff" : "#26262f",
                                  cursor: "pointer",
                                }}
                              />
                              <div
                                className="daily-work-key-word"
                                style={isCredoChecked ? { color: "#fff" } : {}}
                              >
                                CREDO
                              </div>
                              <div
                                class="round"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  id="checkbox-credo"
                                  checked={isCredoChecked}
                                  disabled={isDateOlderThanToday}
                                  onChange={() =>
                                    handleCheckbox("credo", !isCredoChecked)
                                  }
                                />
                                <label
                                  htmlFor="checkbox-credo"
                                  style={{
                                    cursor: isDateOlderThanToday
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                ></label>
                              </div>
                            </div>
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isCredoTooltipOpen} onOpenChange={setIsCredoTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div className="question-mark" onClick={() => setIsCredoTooltipOpen((prev) => !prev)}>?</div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsCredoTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      style={{ zIndex: 9999 }}
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-02-credo.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                          </div>

                          <div className="daily-work-tooltip">
                            <div
                              className="daily-work-track"
                              style={{ marginTop: "3rem" }}
                            >
                              <div
                                className="daily-work-body-item"
                                style={{
                                  borderBottomLeftRadius: "0",
                                  borderBottomRightRadius: "0",
                                  backgroundColor:
                                    trackStatus == "on" ? "#26262f" : "#e5e7eb",
                                  cursor: isDateOlderThanToday
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                              >
                                <div
                                  className="daily-work-key-word"
                                  style={{
                                    marginLeft: "9rem",
                                    color:
                                      trackStatus == "on" ? "#fff" : "#26262f",
                                  }}
                                >
                                  ON TRACK
                                </div>
                                <div class="round">
                                  <input
                                    type="checkbox"
                                    id="checkbox-on"
                                    checked={trackStatus === "on"}
                                    disabled={isDateOlderThanToday}
                                    onChange={() =>
                                      handleTrackCheckboxChange(
                                        trackStatus === "on" ? "" : "on"
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="checkbox-on"
                                    style={{
                                      cursor: isDateOlderThanToday
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  ></label>
                                </div>
                              </div>
                              <div
                                className="daily-work-body-item"
                                style={{
                                  borderTopLeftRadius: "0",
                                  borderTopRightRadius: "0",
                                  backgroundColor:
                                    trackStatus == "off"
                                      ? "#26262f"
                                      : "#e5e7eb",
                                  cursor: isDateOlderThanToday
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                              >
                                <div
                                  className="daily-work-key-word"
                                  style={{
                                    marginLeft: "9rem",
                                    color:
                                      trackStatus == "off" ? "#fff" : "#26262f",
                                  }}
                                >
                                  OFF TRACK
                                </div>
                                <div class="round">
                                  <input
                                    type="checkbox"
                                    id="checkbox-off"
                                    checked={trackStatus === "off"}
                                    disabled={isDateOlderThanToday}
                                    onChange={() =>
                                      handleTrackCheckboxChange(
                                        trackStatus === "off" ? "" : "off"
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="checkbox-off"
                                    style={{
                                      cursor: isDateOlderThanToday
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  ></label>
                                </div>
                              </div>
                            </div>
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isTrackTooltipOpen} onOpenChange={setIsTrackTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsTrackTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsTrackTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+19+On+Track+or+Off+Track.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                          </div>

                          <div className="daily-work-tooltip">
                            <div className="edit-area">
                              {(editWin || textWin?.length > 0) && (
                                <div className="edit-tag">WIN</div>
                              )}
                              <div className="edit-win">
                                <textarea
                                  type="text"
                                  className="win-input"
                                  ref={textWinRef}
                                  placeholder={!editWin ? "WIN" : ""}
                                  readOnly={!editWin}
                                  style={
                                    editWin
                                      ? {
                                          background: "#f3f4f6",
                                          padding: "2rem 1.2rem 0.5rem",
                                        }
                                      : textWin?.length > 0
                                      ? { padding: "2rem 1.2rem 0.5rem" }
                                      : { padding: "0.5rem 11rem" }
                                  }
                                  value={textWin}
                                  onChange={(e) => setTextWin(e.target.value)}
                                  onClick={() => {
                                    if (!editWin && !isDateOlderThanToday) {
                                      handleEdit(
                                        editWin,
                                        setEditWin,
                                        textWinRef
                                      );
                                    }
                                  }}
                                />

                                {!isDateOlderThanToday && (
                                  <div
                                    className="square-pen"
                                    onClick={() =>
                                      handleEdit(
                                        editWin,
                                        setEditWin,
                                        textWinRef
                                      )
                                    }
                                  >
                                    {!editWin ? (
                                      <SquarePen size={16} />
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isWinTooltipOpen} onOpenChange={setIsWinTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsWinTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsWinTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+21+WIN.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                          </div>

                          <div className="daily-work-tooltip">
                            <div className="edit-area">
                              {(editWhat || textWhat?.length > 0) && (
                                <div className="edit-tag">WHAT</div>
                              )}
                              <div className="edit-win">
                                <textarea
                                  type="text"
                                  className="win-input"
                                  ref={textWhatRef}
                                  placeholder={!editWhat ? "WHAT" : ""}
                                  readOnly={!editWhat}
                                  style={
                                    editWhat
                                      ? {
                                          background: "#f3f4f6",
                                          padding: "2rem 1.2rem 0.5rem",
                                        }
                                      : textWhat?.length > 0
                                      ? { padding: "2rem 1.2rem 0.5rem" }
                                      : { padding: "0.5rem 11rem" }
                                  }
                                  value={textWhat}
                                  onChange={(e) => setTextWhat(e.target.value)}
                                  onClick={() => {
                                    if (!editWhat && !isDateOlderThanToday) {
                                      handleEdit(
                                        editWhat,
                                        setEditWhat,
                                        textWhatRef
                                      );
                                    }
                                  }}
                                  // onBlur={() => handleEdit(editWhat, setEditWhat, textWhatRef, textWhat)}
                                />

                                {!isDateOlderThanToday && (
                                  <div
                                    className="square-pen"
                                    onClick={() =>
                                      handleEdit(
                                        editWhat,
                                        setEditWhat,
                                        textWhatRef
                                      )
                                    }
                                  >
                                    {!editWhat ? (
                                      <SquarePen size={16} />
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isWhatTooltipOpen} onOpenChange={setIsWhatTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsWhatTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsWhatTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+23+WHAT.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                          </div>
                        </div>

                        {/* Body Right */}
                        <div className="daily-work-body-right-items">
                          <div className="daily-work-tooltip">
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isMeditateTooltipOpen} onOpenChange={setIsMeditateTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div className="question-mark" onClick={() => setIsMeditateTooltipOpen((prev) => !prev)}>?</div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsMeditateTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+18+Meditation.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                            <div
                              className="daily-work-body-item"
                              style={{
                                backgroundColor: isMeditateChecked
                                  ? "#26262f"
                                  : "",
                                cursor: isDateOlderThanToday
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <ChevronRight
                                size={28}
                                style={{
                                  color: isMeditateChecked ? "#fff" : "#26262f",
                                  cursor: "pointer",
                                  visibility: "hidden",
                                }}
                              />
                              <div
                                className="daily-work-key-word"
                                style={
                                  isMeditateChecked ? { color: "#fff" } : {}
                                }
                              >
                                MEDITATE
                              </div>
                              <div class="round">
                                <input
                                  type="checkbox"
                                  id="checkbox-meditate"
                                  disabled={isDateOlderThanToday}
                                  checked={isMeditateChecked}
                                  onChange={() =>
                                    handleCheckbox(
                                      "meditate",
                                      !isMeditateChecked
                                    )
                                  }
                                />
                                <label
                                  htmlFor="checkbox-meditate"
                                  style={{
                                    cursor: isDateOlderThanToday
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                ></label>
                              </div>
                            </div>
                          </div>

                          <div className="daily-work-tooltip">
                            <Tooltip.Provider>
                             <Tooltip.Root  open={isCorrectionTooltipOpen} onOpenChange={setIsCorrectionTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsCorrectionTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsCorrectionTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+20+Course+Correction.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                            <div className="edit-area">
                              {(textCorrection?.length > 0 ||
                                editCorrection) && (
                                <div className="edit-tag">CORRECTION</div>
                              )}
                              <div className="edit-win">
                                <textarea
                                  type="text"
                                  className="win-input"
                                  ref={textCorrectionRef}
                                  placeholder={
                                    !editCorrection ? "CORRECTION" : ""
                                  }
                                  readOnly={!editCorrection}
                                  style={
                                    editCorrection
                                      ? {
                                          background: "#f3f4f6",
                                          padding: "2rem 1.2rem 0.5rem",
                                        }
                                      : textCorrection?.length > 0
                                      ? { padding: "2rem 1.2rem 0.5rem" }
                                      : { padding: "0.5rem 9rem" }
                                  }
                                  value={textCorrection}
                                  onChange={(e) =>
                                    setTextCorrection(e.target.value)
                                  }
                                  onClick={() => {
                                    if (
                                      !editCorrection &&
                                      !isDateOlderThanToday
                                    ) {
                                      handleEdit(
                                        editCorrection,
                                        setEditCorrection,
                                        textCorrectionRef
                                      );
                                    }
                                  }}
                                />

                                {!isDateOlderThanToday && (
                                  <div
                                    className="square-pen"
                                    onClick={() =>
                                      handleEdit(
                                        editCorrection,
                                        setEditCorrection,
                                        textCorrectionRef
                                      )
                                    }
                                  >
                                    {!editCorrection ? (
                                      <SquarePen size={16} />
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="daily-work-tooltip">
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isWishTooltipOpen} onOpenChange={setIsWishTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsWishTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsWishTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+22+WISH.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                            <div className="edit-area">
                              {(editWish || textWish?.length > 0) && (
                                <div className="edit-tag">WISH</div>
                              )}
                              <div className="edit-win">
                                <textarea
                                  type="text"
                                  className="win-input"
                                  ref={textWishRef}
                                  placeholder={!editWish ? "WISH" : ""}
                                  readOnly={!editWish}
                                  style={
                                    editWish
                                      ? {
                                          background: "#f3f4f6",
                                          padding: "2rem 1.2rem 0.5rem",
                                        }
                                      : textWish?.length > 0
                                      ? { padding: "2rem 1.2rem 0.5rem" }
                                      : { padding: "0.5rem 11rem" }
                                  }
                                  value={textWish}
                                  onChange={(e) => setTextWish(e.target.value)}
                                  onClick={() => {
                                    if (!editWish && !isDateOlderThanToday) {
                                      handleEdit(
                                        editWish,
                                        setEditWish,
                                        textWishRef
                                      );
                                    }
                                  }}
                                />

                                {!isDateOlderThanToday && (
                                  <div
                                    className="square-pen"
                                    onClick={() =>
                                      handleEdit(
                                        editWish,
                                        setEditWish,
                                        textWishRef
                                      )
                                    }
                                  >
                                    {!editWish ? (
                                      <SquarePen size={16} />
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="daily-work-tooltip">
                            <Tooltip.Provider>
                              <Tooltip.Root  open={isWhoTooltipOpen} onOpenChange={setIsWhoTooltipOpen}>
                                <Tooltip.Trigger asChild>
                                  <div
                                    className="question-mark"
                                    style={{ marginTop: "3rem" }}
                                    onClick={() => setIsWhoTooltipOpen((prev) => !prev)}
                                  >
                                    ?
                                  </div>
                                </Tooltip.Trigger>
                                <Tooltip.Portal>
                                  <Tooltip.Content
                                    className="TooltipContent"
                                    sideOffset={5}
                                    onPointerDownOutside={() => setIsWhoTooltipOpen(false)}
                                  >
                                    <video
                                      width="360"
                                      height="240"
                                      controls
                                      src="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+24+WHO.mp4"
                                    ></video>
                                    <Tooltip.Arrow className="TooltipArrow" />
                                  </Tooltip.Content>
                                </Tooltip.Portal>
                              </Tooltip.Root>
                            </Tooltip.Provider>
                            <div className="edit-area">
                              {(editWho || textWho?.length > 0) && (
                                <div className="edit-tag">WHO</div>
                              )}
                              <div className="edit-win">
                                <textarea
                                  type="text"
                                  className="win-input"
                                  ref={textWhoRef}
                                  placeholder={!editWho ? "WHO" : ""}
                                  readOnly={!editWho}
                                  style={
                                    editWho
                                      ? {
                                          background: "#f3f4f6",
                                          padding: "2rem 1.2rem 0.5rem",
                                        }
                                      : textWho?.length > 0
                                      ? { padding: "2rem 1.2rem 0.5rem" }
                                      : { padding: "0.5rem 11rem" }
                                  }
                                  value={textWho}
                                  onChange={(e) => setTextWho(e.target.value)}
                                  onClick={() => {
                                    if (!editWho && !isDateOlderThanToday) {
                                      handleEdit(
                                        editWho,
                                        setEditWho,
                                        textWhoRef
                                      );
                                    }
                                  }}
                                />

                                {!isDateOlderThanToday && (
                                  <div
                                    className="square-pen"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleEdit(
                                        editWho,
                                        setEditWho,
                                        textWhoRef
                                      );
                                    }}
                                  >
                                    {!editWho ? (
                                      <SquarePen size={16} />
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : isSaturday && !isSunday ? (
                    <SaturdayComp weeklyScore={score} />
                  ) : (
                    <SundayComp isDateOlderThanToday={isDateOlderThanToday} />
                  )}
                </div>
              </div>
            </div>
          </div>

          {!isSaturday && (
            <div className="main-targets">
              <button
                type="button"
                className="main-target-btn"
                onClick={toggleNext30Modal}
              >
                <span className="main-target-button__label">NEXT 30</span>
              </button>
              <button
                type="button"
                className="main-target-btn"
                onClick={toggleIgnitionModal}
              >
                <span className="main-target-button__label">
                  IGNITE YOUR 🔥🔥🔥
                </span>
              </button>

              <button
                type="button"
                className="main-target-btn"
                onClick={toggleNext90Modal}
              >
                <span className="main-target-button__label">NEXT 90</span>
              </button>
            </div>
          )}
        </div>
      </div>
      {activeKey !== null && (
        <KeyModal
          isOpen={true}
          onClose={closeKeyModal}
          keyData={keys.find((key) => key.id === activeKey)}
          selectedDate={selectedDate}
          isDateOlderThanToday={isDateOlderThanToday}
        />
      )}
      <CredoModal
        isOpen={credoModal}
        onClose={closeCredoModal}
        isDateOlderThanToday={isDateOlderThanToday}
      />
      <Next90Modal isOpen={next90Modal} onClose={toggleNext90Modal} />
      <Next30Modal isOpen={next30Modal} onClose={toggleNext30Modal} />
      <IgniteModal isOpen={ignitionModal} onClose={toggleIgnitionModal} />
    </>
  ) : (
    <div className="member-loader">
      <HashLoader color="#d1b794" size={32} />
      <p style={{ color: "#26262f" }}>Loading Your Daily Progress</p>
    </div>
  );
};

export default DailyWork;
